module.exports = __webpack_public_path__ + "static/media/Galileo_bossDied.788f5295.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/Galileo_bossDied.wav
// module id = 189
// module chunks = 0